var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LayoutUser"},[(_vm.showMenu)?_c('AdminMenu'):_vm._e(),_c('user-header',{attrs:{"showLogout":_vm.showLogout,"showBadges":_vm.showBadges}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }